import { openModal } from './openModal';

export const handleOpenTriggerClick = (event, modal) => {
  event.preventDefault();
  openModal(modal);
};
